(function () {
    'use strict';

    angular
        .module('app')
        .controller('DashboardSettingOrderingCtrl', DashboardSettingOrderingCtrl);

    DashboardSettingOrderingCtrl.$inject = ['$q', '$scope', 'DashboardSettingsService', 'DialogService', 'entityTemplates', 'DialogInstance'];

    function DashboardSettingOrderingCtrl($q, $scope, DashboardSettingsService, DialogService, entityTemplates, DialogInstance) {
        /* jshint validthis:true */
        var vm = this;
        vm.getDashboardSettingName = getDashboardSettingName;
        vm.getDashboardSettingDescription = getDashboardSettingDescription;
        vm.ok = ok;
        vm.cancel = cancel;
        vm.loading = true;

        activate();

        function activate() {
            var loadPromises = [];
            loadPromises.push(loadDashboardSettings());

            $q.all(loadPromises).then(function () {
                vm.loading = false;
            });


            $scope.dashboardSettingDragListener = {
                accept: function (sourceItemHandleScope, destSortableScope) {
                    return sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id;
                },
                containment: '#dashboardSettingList',
                containerPositioning: 'relative'
            };
        }

        function loadDashboardSettings() {
            return DashboardSettingsService.query({
            })
                .then(getDashboardSettingsOk, getDashboardSettingsError);

            function getDashboardSettingsOk(data) {
                vm.dashboardSettings = angular.copy(data.DashboardSettings);
            }

            function getDashboardSettingsError(response) {
                DialogService.error('Error fetching Dashboard Panels', response);
            }
        }

        function ok() {
            var toUpdateList = [];
            var increment = 0;
            var orderChanged = false;

            angular.forEach(vm.dashboardSettings, function (dashboardSetting) {
                if (dashboardSetting.DisplayOrder !== increment) {
                    var updatedDashboardSetting = angular.copy(dashboardSetting);
                    updatedDashboardSetting.DisplayOrder = increment;
                    toUpdateList.push(updatedDashboardSetting);

                    orderChanged = true;
                }

                increment++;
            });

            if (orderChanged) {
                var savePromises = [];

                angular.forEach(toUpdateList, function (dashboardSetting) {
                    savePromises.push(saveDashboardSetting(dashboardSetting));
                });

                $q.all(savePromises).then(function () {
                    DialogInstance.ok(orderChanged);
                });
            }
            else {
                DialogInstance.ok(orderChanged);
            }
        }

        function saveDashboardSetting(dashboardSetting) {
            return DashboardSettingsService.save(dashboardSetting)
                .then(saveDashboardSettingOk, saveDashboardSettingError);

            function saveDashboardSettingOk(success) {
            }

            function saveDashboardSettingError(response) {
                DialogService.error('Error saving Dashboard Panel', response);
            }
        }

        function cancel() {
            DialogInstance.cancel();
        }

        /*
         * Get the user friendly name for the supplied dashboard setting.
         *
         * @returns {string} - Returns user friendly dashboard setting name
         */
        function getDashboardSettingName(dashboardSetting) {
            var name = '';

            switch (dashboardSetting.Type) {
                case 'Entities':
                    var entityTemplate = _.find(entityTemplates, function (n) { return n.Id === dashboardSetting.EntityTemplateId; });

                    if (!_.isNil(entityTemplate)) {
                        name = entityTemplate.PluralName;
                    }
                    break;
            }

            return name;
        }

        /*
         * Get the user friendly description for the supplied dashboard setting.
         *
         * @returns {string} - Returns user friendly dashboard setting description
         */
        function getDashboardSettingDescription(dashboardSetting) {
            var description = '';

            switch (dashboardSetting.Type) {
                case 'Entities':
                    var entityTemplate = _.find(entityTemplates, function (n) { return n.Id === dashboardSetting.EntityTemplateId; });

                    if (!_.isNil(entityTemplate)) {
                        description = entityTemplate.Description;
                    }
                    break;
            }

            return description;
        }
    }
})();
